// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import styles from "./BlogNew2.module.css";
// import Gfooter from "../Component/Gfooter";

// const containerVariants = {
//   hidden: {},
//   show: {
//     transition: {
//       staggerChildren: 0.1,
//     },
//   },
// };

// const cardVariants = {
//   hidden: { opacity: 0, y: 60, scale: 0.97 },
//   show: {
//     opacity: 1,
//     y: 0,
//     scale: 1,
//     transition: { duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] },
//   },
// };

// const heroVariants = {
//   hidden: { opacity: 0, y: -30 },
//   show: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.8, ease: "easeOut" },
//   },
// };

// function BlogNew2() {
//   const [blogs, setBlogs] = useState([]);

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   const fetchBlogs = async () => {
//     try {
//       const res = await axios.get(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_blog_card"
//       );
//       setBlogs(res.data.data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   return (
//     <div className={styles.wrapper}>
//       {/* ── HERO ── */}
//       <motion.div
//         className={styles.hero}
//         variants={heroVariants}
//         initial="hidden"
//         animate="show"
//       >
//         <div className={styles.heroNoise} />
//         <div className={styles.heroLine} />
//         <h1 className={styles.heroTitle}>
//           Our <span>Blogs</span>
//         </h1>
//         <p className={styles.heroSub}>Stories · Insights · Ideas</p>
//       </motion.div>

//       {/* ── GRID ── */}
//       <AnimatePresence>
//         <motion.div
//           className={styles.grid}
//           variants={containerVariants}
//           initial="hidden"
//           animate="show"
//         >
//           {blogs.map((blog, index) => (
//             <motion.div
//               key={blog.id}
//               className={styles.card}
//               variants={cardVariants}
//               whileHover={{ zIndex: 2 }}
//             >
//               <img
//                 src={`https://cyberathon.com/NLF/${blog.blog_image}`}
//                 alt={blog.title}
//                 className={styles.cardImage}
//               />
//               <div className={styles.cardGradient} />
//               <div className={styles.cardRedAccent} />

//               <div className={styles.cardBody}>
//                 <span className={styles.cardNum}>
//                   {String(index + 1).padStart(2, "0")}
//                 </span>
//                 <div className={styles.cardTag}>NLF Editorial</div>
//                 <h3 className={styles.cardTitle}>{blog.title}</h3>
//                 <p className={styles.cardDesc}>{blog.description}</p>
//                 <div className={styles.cardFooter}>
//                   <span className={styles.cardDate}>
//                     {blog.day} {blog.month} {blog.year}
//                   </span>
//                   <Link to={`/blog/${blog.id}`} className={styles.cardBtn}>
//                     <svg viewBox="0 0 24 24">
//                       <line x1="5" y1="12" x2="19" y2="12" />
//                       <polyline points="12 5 19 12 12 19" />
//                     </svg>
//                   </Link>
//                 </div>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>
//       </AnimatePresence>

//       <Gfooter />
//     </div>
//   );
// }

// export default BlogNew2;

import { Helmet } from 'react-helmet-async';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import styles from "./BlogNew22.module.css";
import Gfooter from "../Component/Gfooter";

const containerVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.1 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

const headingVariants = {
  hidden: { opacity: 0, y: -20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

function BlogNew2() {
  const [blogs, setBlogs] = useState([]);

 const createSlug = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_blog_card"
      );
      console.log(res.data);
      setBlogs(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (

    <>
      <Helmet>
        <title>Architectural Solutions & Building Industry Blog | NLF</title>
        <meta name="description" content="Read the NLF Solutions blog for insights, trends and expert information on architectural solutions, metal ceilings, facades, roofing, furniture and acoustics." />
        <link rel="canonical" href="https://nlfs.in/blognew2" />
      </Helmet>
      <h1 style={{ display: 'none' }}>Architecture & Design Insights</h1>

      <h1 style={{ display: 'none', }}>Architecture & Design Insights</h1>
      <div className={styles.wrapper}>

        {/* ── HEADER ── */}
        <motion.div
          className={styles.header}
          variants={headingVariants}
          initial="hidden"
          animate="show"
        >
          <div className={styles.eyebrow}>NLF Editorial</div>
          <h2 className={styles.heading}>Blogs</h2>
        </motion.div>

        {/* ── GRID ── */}
        <motion.div
          className={styles.grid}
          variants={containerVariants}
          initial="hidden"
          animate="show"
        >
          {blogs.map((blog, index) => (
            <motion.div
              key={blog.id}
              className={styles.card}
              variants={cardVariants}
            >
              {/* Image */}
              <div className={styles.imgWrapper}>
                <img
                  src={`https://cyberathon.com/NLF/${blog.blog_image}`}
                  alt={blog.title}
                  className={styles.cardImg}
                />
                <div className={styles.imgTag}>Article</div>
              </div>

              {/* Body */}
              <div className={styles.cardBody}>
                <span className={styles.cardIndex}>
                  {String(index + 1).padStart(2, "0")}
                </span>

                <h5 className={styles.cardTitle}>{blog.title}</h5>
                {/* <p className={styles.cardDesc} dangerouslySetInnerHTML={{ __html: blog.description }}></p> */}

                <div className={styles.cardFooter}>
                  <span className={styles.cardDate}>
                    {blog.day} {blog.month} {blog.year}
                  </span>

                  {/* <Link to={`/blog/${blog.id}`} className={styles.cardBtn}> */}
                  <Link
  to={`/blogRead/${blog.slug || createSlug(blog.seo_title || blog.title)}`}
  className={styles.cardBtn}
>
                    <svg viewBox="0 0 24 24">
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <Gfooter />
      </div>
    </>
  );
}

export default BlogNew2;